import { Box, Button, Flex, Heading, Image, Text } from '@chakra-ui/core';
import { ChevronRightIcon } from '@chakra-ui/icons';
import React, { useEffect, useState } from 'react';
import PreviewOfferImage from '../../assets/preview_offer.png';
import MailchimpForm from '../../components/MailchimpForm';

const BetLink = ({ onNext, betId, name, staticPubkey }) => {
  const [mailchimpModalOpen, setMailchimpModalOpen] = useState(
    !window.localStorage.getItem('mailchimpSet')
  );
  useEffect(() => {
    const mailchimpSet = window.localStorage.getItem('mailchimpSet');
    setMailchimpModalOpen(!mailchimpSet);
  }, []);

  return (
    <>
      <Flex flexDir="column" alignItems="center">
        <Heading as="h3" fontSize="xl" textAlign="center" mb={2}>
          You've accepted {name}'s Offer.
        </Heading>
        <Text fontWeight="500" fontSize="sm" textAlign="center">
          Once {name} finalizes the bet from his end, you will then have 36
          hours to finalize the bet from your side.
        </Text>

        <Box
          position="relative"
          borderRadius="8px"
          overflow="hidden"
          w="300px"
          h="170px"
          my={4}
        >
          <Flex
            alignItems="center"
            justifyContent="center"
            position="absolute"
            top={0}
            cursor="pointer"
            onClick={() => window.open(`/odds/app/bet/${betId}`)}
            left={0}
            boxSize="full"
          >
            <Text
              color="white"
              fontWeight="bold"
              zIndex="1"
              pointerEvents="none"
            >
              Preview Bet Page
            </Text>
            <Box
              position="absolute"
              transition="opacity 0.1s linear"
              _hover={{
                opacity: 0.7,
              }}
              opacity="0.57"
              bg="#000000"
              boxSize="full"
            />
          </Flex>
          <Image src={PreviewOfferImage} />
        </Box>

        <Text fontSize="xs" mt={2}>
          You can also find this bet under the "Active Offers" tab on your
          Dashboard
        </Text>
      </Flex>
      <Flex flexDir="row" mt={8}>
        <Button
          ml="auto"
          colorScheme="blue"
          rightIcon={<ChevronRightIcon />}
          onClick={() => {
            onNext();
          }}
        >
          Go to Dashboard
        </Button>
      </Flex>
      <MailchimpForm
        mailchimpFormOpen={mailchimpModalOpen}
        twitterName={name}
        onNext={() => setMailchimpModalOpen(false)}
        staticPubkey={staticPubkey}
      />
    </>
  );
};

export default BetLink;
